module.exports = __webpack_public_path__ + "img/daruebereinfuegen.d230306.svg";